import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
  viewPaper: {
    borderRadius: 8,
    height: 610
  },
  viewPaperV1: {
    borderRadius: 8,
    // height: '68%'
  },
  journeyPage:{
    padding:15
  },
  tripActionDiv: {
    padding: 16
  },
  tripActionButton: {
    width: '100%',
    paddingTop: 19,
    paddingBottom: 19,
    backgroundColor: '#161f34',
    textTransform: 'capitalize',
    color: '#fff',
    fontWeight: 300,
    '&:hover': {
      backgroundColor: '#0033cc'
    }
  },
  summarySection: {
    boxShadow: 'none',
    borderRadius: 0,
    //overflow:'auto',
    //padding:16,
    //height:'calc(100vh - 500px)'

  },
  mtV1: {
    marginTop: 8
  },
  mtV2: {
    marginTop: '2em'
  },
  mtV3: {
    marginTop: '1em'
  },
  title: {
    color: '#9ea0a5',
    // fontSize: 12
  },
  titleV1: {
    backgroundColor: '#E8E8E8',
    minHeight: '2em',
    display: 'flex',
    alignItems: 'center',
    // fontSize: 12
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    paddingLeft: 14
  }
}));
export default useStyles;